import { useState } from "react";
import { Text, LoadingIndicator, Button, Flex } from "@simplybusiness/mobius";
import { errorState, successState, declinedState } from "../values";

const text = {
  transfer: {
    header: "No quotes showing?",
    body: [
      `We can't currently offer you a quote but our partner, 
      Gallagher, might be able to help you.`,
      `Gallagher has a team of specialists that can offer
      you insurance advice and guidance, as well as your own dedicated account handler.`,
      `As one of the world's largest insurance brokers, Gallagher supports
      thousands of businesses with tailored insurance advice to arrange either standard or
      specialist business insurance.`,
      `If you're happy for us to hand over your details to Gallagher, 
      they might be able to provide you with a quote.`,
    ],
  },
};

export interface TransferConsentFormUKProps {
  transferUrl: string;
  csrfToken: string;
  transferState: (stateParams: { state: string; response: unknown }) => void;
}

export const TransferConsentFormUK = ({
  transferUrl = "https://default.url",
  csrfToken = "defaultToken",
  transferState = () => console.log("default state"),
}: TransferConsentFormUKProps) => {
  const [loading, setLoadingState] = useState(false);

  const handleSubmit = async (option: "yes" | "no") => {
    setLoadingState(true);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const response = await fetch(transferUrl, {
      method: "POST",
      body: JSON.stringify({ consent: option === "yes" }),
      headers: {
        "X-CSRF-Token": csrfToken,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }).then(res => res.json());

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const result = response.success ? successState : errorState;
    const stateParams = {
      state: option === "yes" ? result : declinedState,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      response,
    };

    transferState(stateParams);
  };

  return (
    <div>
      <Text elementType="h2">{text.transfer.header}</Text>
      {text.transfer.body.map(message => (
        <Text key={message}>{message}</Text>
      ))}
      {loading ? (
        <div className="mobius-transfer-consent__styled-div">
          <LoadingIndicator size="lg" data-testid="loading-indicator" />
        </div>
      ) : (
        <Flex
          className="mobius-transfer-consent__styled-button-container"
          gap="xs"
        >
          <Button
            size="sm"
            variant="secondary"
            onClick={() => {
              handleSubmit("yes").catch(console.error);
            }}
          >
            Yes
          </Button>
          <Button
            size="sm"
            variant="secondary"
            onClick={() => {
              handleSubmit("no").catch(console.error);
            }}
          >
            No
          </Button>
        </Flex>
      )}
    </div>
  );
};
